<ng-container
  *ngIf="{
    requisitionDetailsRequest: requisitionDetailsRequest$ | async,
    roleRequisition: roleRequisition$ | async,
  } as content"
>
  @if (!content.requisitionDetailsRequest?.isPristine) {
    @if (!content.requisitionDetailsRequest?.isLoading) {
      @if (!content.requisitionDetailsRequest?.hasError) {
        <div class="container-modal-request-details container-modal-role-details">
          <p>
            <span class="title">{{ 'approvalspage.modalRoleDetails.nameOfApplicant' | cxTranslate }}: </span>
            <span class="value"> {{ content.roleRequisition?.user }} </span>
          </p>

          <p>
            <span class="title">{{ 'approvalspage.modalRoleDetails.currentRole' | cxTranslate }}: </span>
            <span class="value"> {{ content.roleRequisition?.roleRequest?.previousUserGroup }} </span>
          </p>

          <p>
            <span class="title">{{ 'approvalspage.modalRoleDetails.requestedRole' | cxTranslate }}: </span>
            <span class="value"> {{ content.roleRequisition?.roleRequest?.userGroup }} </span>
          </p>

          <div class="m-t-8">
            <p class="title">{{ 'approvalspage.modalRoleDetails.currentAccounts' | cxTranslate }}</p>

            @if (content.roleRequisition?.roleRequest?.linkedAccounts?.length) {
              <ul class="list inverted">
                <li *ngFor="let account of content.roleRequisition?.roleRequest?.linkedAccounts">{{ account }}</li>
              </ul>
            } @else {
              <p class="text-center m-0">{{ 'approvalspage.modalRoleDetails.noLinkedAccount' | cxTranslate }}</p>
            }
          </div>

          @if (data.requisition.status === REQUEST_STATUS.PENDING) {
            <form [formGroup]="form" (submit)="validation()">
              <div class="form-group m-b-0 m-t-20">
                <div class="form-check m-0">
                  <label class="m-0">
                    <input type="checkbox" formControlName="Iagree" />
                    <span class="form-check-label">{{ 'approvalspage.modalRoleDetails.approvalAffectsAllAccounts' | cxTranslate }}</span>
                  </label>
                </div>
                <cx-form-errors [control]="form.get('Iagree')"></cx-form-errors>
              </div>
            </form>
          }

          @if (content.roleRequisition?.code && content.roleRequisition?.status) {
            <modal-request-actions
              [code]="content.roleRequisition?.code!"
              [status]="content.roleRequisition?.status!"
              [approvalsUser]="content.roleRequisition?.approvalUser || undefined"
              [approvalsDate]="content.roleRequisition?.approvalDate || undefined"
              [validation]="validation.bind(this)"
              [replyConfig]="replyConfig"
              (_onReply)="reply($event)"
              (_onClose)="close()"
            ></modal-request-actions>
          }
        </div>
      } @else {
        <alert [alert]="alertMessage"></alert>
      }
    } @else {
      <local-loader></local-loader>
    }
  }
</ng-container>